import { AxiosPrivateFirebaseInstance } from 'settings';
import { IResponse } from 'types';
import { IFeatureFlagsGlobal } from 'types/featureFlags';

export const getFeatureFlags = async () =>
  AxiosPrivateFirebaseInstance.get<IResponse<IFeatureFlagsGlobal>>(
    '/featureFlags'
  );
